import React, { FC, PropsWithChildren } from 'react';

export const NoWrap: FC<PropsWithChildren<{}>> = props => {
    return <span style={{ whiteSpace: 'nowrap' }}>{props.children}</span>;
};
